module.exports = __webpack_public_path__ + "static/media/article-card-default@2x.76151776.jpg";